module.exports = __webpack_public_path__ + "static/media/040-money.051ab1f4.svg";